/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F3_AInputs */

const en_mk_sec_pg_f3_a = /** @type {(inputs: Mk_Sec_Pg_F3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, unless that agent has been given explicit access to the channel. By default an agent sees only its division’s channels and public ones.`)
};

const id_mk_sec_pg_f3_a = /** @type {(inputs: Mk_Sec_Pg_F3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak, kecuali agen itu diberi akses eksplisit ke channel tersebut. Secara bawaan agen hanya melihat channel divisinya dan channel publik.`)
};

/**
* | output |
* | --- |
* | "No, unless that agent has been given explicit access to the channel. By default an agent sees only its division’s channels and public ones." |
*
* @param {Mk_Sec_Pg_F3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f3_a = /** @type {((inputs?: Mk_Sec_Pg_F3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f3_a(inputs)
	return en_mk_sec_pg_f3_a(inputs)
});